import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Product} from "../../../../store/state/order.state";
import {UmbrellaValidators} from "../../../../umbrella-common/validation/umbrella-validators";
import {distinctUntilChanged} from "rxjs/operators";
import {OrderActions} from "../../../../store/actions/order.actions";
import {AppState} from "../../../../store/state/app.state";
import {Store} from "@ngrx/store";
import {FormService} from "../../../../umbrella-common/services/form.service";
import {BaseFormControlHandler} from "./form-control.handler";
import {Injectable} from "@angular/core";

@Injectable()
export class CompanyDescriptionHandler extends BaseFormControlHandler {

	private companyDescriptionChanged: boolean = false;

	constructor(private fb: FormBuilder, private store: Store<AppState>) {
		super();
	}

	buildControls(form: FormGroup, product: Product) {
		const control = this.fb.control(product.companyDescription, [Validators.required, UmbrellaValidators.textLengthBetween(10, 5000)]);
		this.addSubscription(product.standard.name, control.valueChanges.pipe(distinctUntilChanged())
			.subscribe((companyDescription: string) => {
				// workaround for IE
				if ((!companyDescription || companyDescription.trim() === '') && this.companyDescriptionChanged) {
					this.store.dispatch(OrderActions.SET_COMPANY_DESCRIPTION({
						standardName: product.standard.name,
						description: companyDescription
					}));
				} else if (companyDescription && companyDescription.trim() !== '') {
					this.companyDescriptionChanged = true;
					this.store.dispatch(OrderActions.SET_COMPANY_DESCRIPTION({
						standardName: product.standard.name,
						description: companyDescription
					}));
				}
			}));

		form.addControl(`companyDescription${(product.standard.name)}`, control);
	}

	protected fillProduct(formService: FormService, srcForm: string, product: Product): void {
		product.companyDescription = formService.getValueFor('companyDescription', srcForm);
	}
}
